export default __webpack_public_path__ + "7cfd0bac93a1d8d24bae388646cb22e7.svg";